import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {ServiceRequestStatus} from '../../util/uiconstants';

export default function taskServiceRequestsReducer(state = initialstate.taskServiceRequests, action) {
	switch (action.type) {
		case types.GET_TASK_SERVICE_REQUESTS:
			if (action.response) {
				return action.response.data || state;
			}
			return state;
		case types.RESET_TASK_ATTRIBUTES:
			return initialstate.serviceRequests;
		default:
			return state;
	}
}
